/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

import React from 'react';

/**
 * An event's status as a word rather than a constant.
 *
 * Only DRAFT and PUBLISHED can be authored; the rest are set by the platform's
 * scheduled sweep and are shown here because an organizer still needs to know
 * which one an event is in. An unrecognised value renders as itself — a status
 * added to the pack later should show up as something odd-looking, not vanish.
 */

const LABELS = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  REGISTRATION_OPEN: 'Registration open',
  REGISTRATION_CLOSED: 'Registration closed',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

/**
 * The colour each status wears.
 *
 * Chosen so a glance down the list separates what needs attention from what
 * does not, rather than merely distinguishing published from unpublished:
 *
 *   off      — grey. Not live: a draft nobody can see, or a window now shut.
 *   orgf-go  — green. Live and healthy; nothing to do.
 *   ok       — accent. Live AND taking signups — the state worth looking at,
 *              because capacity and the closing date are both moving.
 *   orgf-done— muted green. Finished. Good news, but not news.
 *   warn     — red. Cancelled; the one state that is genuinely bad.
 */
const TONE = {
  DRAFT: 'off',
  PUBLISHED: 'orgf-go',
  REGISTRATION_OPEN: 'ok',
  REGISTRATION_CLOSED: 'off',
  COMPLETED: 'orgf-done',
  CANCELLED: 'warn',
};

export default function EventStatusPill({ status }) {
  return (
    <span className={`org-pill ${TONE[status] || 'off'}`}>
      {LABELS[status] || status}
    </span>
  );
}
